import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<title>alert / error</title><desc>Created with Sketch.</desc><g id=\"alert-/-error\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"toast-/-negative\"><g><g id=\"Group-3\"><rect id=\"Rectangle\" stroke=\"#979797\" fill=\"#D8D8D8\" opacity=\"0\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect><path class=\"gst-svg-icon\" d=\"M12,3 C7.032,3 3,7.032 3,12 C3,16.968 7.032,21 12,21 C16.968,21 21,16.968 21,12 C21,7.032 16.968,3 12,3 Z M12,12.9 C11.505,12.9 11.1,12.495 11.1,12 L11.1,8.4 C11.1,7.905 11.505,7.5 12,7.5 C12.495,7.5 12.9,7.905 12.9,8.4 L12.9,12 C12.9,12.495 12.495,12.9 12,12.9 Z M12.9,16.5 L11.1,16.5 L11.1,14.7 L12.9,14.7 L12.9,16.5 Z\" id=\"Shape\" fill=\"#23262D\" fill-rule=\"nonzero\"></path></g></g></g></g>", 3)
const _hoisted_5 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render };